import React, { useRef, useState, useEffect } from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from "recharts";

const SHORT = {
  relationship: "REL", decision: "DEC", trust: "TRU", influence: "INF",
  opportunity: "OPP", risk: "RSK", knowledge: "KNW", ai: "AIM",
};

export default function LayerRadar({ layers = [], scores = {}, height = 300 }) {
  const ref = useRef(null);
  const [w, setW] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => setW(entries[0].contentRect.width));
    ro.observe(el);
    setW(el.clientWidth);
    return () => ro.disconnect();
  }, []);

  const data = layers.map((l) => ({
    layer: SHORT[l.id] || l.code,
    value: Number(scores[l.id] || 0),
  }));

  return (
    <div ref={ref} style={{ width: "100%", height }} data-testid="layer-radar">
      {w > 0 && (
        <RadarChart width={w} height={height} data={data} cx="50%" cy="50%" outerRadius="72%">
          <PolarGrid stroke="rgba(240,163,21,0.18)" />
          <PolarAngleAxis dataKey="layer" tick={{ fill: "#94A3B8", fontSize: 11, fontFamily: "JetBrains Mono" }} />
          <PolarRadiusAxis domain={[0, 100]} tickCount={5} tick={false} axisLine={false} />
          <Radar dataKey="value" stroke="#F0A315" fill="#F1551D" fillOpacity={0.4} strokeWidth={2} dot={{ r: 2.5, fill: "#F0A315", strokeWidth: 0 }} isAnimationActive={false} />
        </RadarChart>
      )}
    </div>
  );
}
